/**
 * YARG IE11 you darn thing. This one's simple enough we'll just do it ourselves.
 * https://caniuse.com/?search=findIndex
 */
export var findIndex = function findIndex(arr, fn) {
  for (var index = 0; index < arr.length; index++) {
    if (fn(arr[index])) {
      return index;
    }
  }
  return -1;
};
//# sourceMappingURL=findIndex.js.map